<template>
  <div id="shopping-car">
    <div class="wrap">
      <div class="wrap_zh">
        <div class="shopping-title">
          <div class="shopping-title_name fl">我的购物车</div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="wrap_zh shopping-car">
        <div class="shopping-car-table fl">
          <div class="shopping-car-table_head fl">
            <div class="shopping-car-table_head-td shopping-table_select fl">
              <span
                class="shopping-select"
                :class="selectedAll == 1 && 'on'"
                @click="operaAllSelect"
              >
                <font v-if="selectedAll == 1">✔</font>
              </span>
              <font @click="operaAllSelect">全选</font>
            </div>
            <div class="shopping-car-table_head-td shopping-table_goods fl">商品信息</div>
            <div class="shopping-car-table_head-td shopping-table_price fl">单价</div>
            <div class="shopping-car-table_head-td shopping-table_num fl">数量</div>
            <div class="shopping-car-table_head-td shopping-table_computed fl">小计</div>
            <div class="shopping-car-table_head-td shopping-table_do fl">操作</div>
          </div>
          <div class="shopping-car-table_body fl">
            <div
              class="shopping-car-table_body-li fl"
              v-for="(item,index) in shoppingCarGoods"
              :key="index"
              v-if="item.hanld"
            >
              <div class="shopping-car-table_head-td shopping-table_select fl">
                <span
                  class="shopping-select"
                  :class="item.selected == 1 && 'on'"
                  @click="operaStandSelect(item,index)"
                >
                  <font v-if="item.selected == 1">✔</font>
                </span>
              </div>
              <div class="shopping-car-table_head-td shopping-table_goods fl">
                <div class="shopping-car_goods-find">
                  <div class="shopping-car_goods-find-img fl">
                    <img :src="item.productImgUrl">
                  </div>
                  <dl>
                    <dt>
                      {{item.productName}}
                      <font>（{{item.productSpec}}）</font>
                    </dt>
                    <dd>
                      <font v-for="(vals,i) in item.productLabels" v-if="i < 3" :key="vals.id">{{vals.labelName}}</font>
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="shopping-car-table_head-td shopping-table_price shopping-center fl">
                <font>¥ {{item.price}}</font>
              </div>
              <div class="shopping-car-table_head-td shopping-table_num shopping-center fl">
                <div class="shopping-pro-infos_num-compute fl">
                  <el-input-number
                    :min="1"
                    label="数量"
                    v-model="item.quantity"
                    @change="operaHandleChange(item,index)"
                  ></el-input-number>
                </div>
              </div>
              <div class="shopping-car-table_head-td shopping-table_computed shopping-center fl">
                <font class="shopping-red">¥ {{item.subtotal}}</font>
              </div>
              <div class="shopping-car-table_head-td shopping-table_do shopping-center fl">
                <span @click="operaShoppingCarDelete(item,index)">
                  <img src="../../assets/images/shopping/shoppingcart_icon_delete.png" title="删除">
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="wrap_zh shopping-settlement">
        <div class="shopping-set fl">
          <div class="shopping-set_sel">
            <span
              class="shopping-selected"
              :class="selectedAll == 1 && 'on'"
              @click="operaAllSelect"
            >
              <font v-if="selectedAll == 1">✔</font>
            </span>
            <font @click="operaAllSelect">全选</font>
            <span class="shopping-delete" @click="operaShoppingCarDelete('all')">
              <img src="../../assets/images/shopping/shoppingcart_icon_delete.png" title="删除">
            </span>
            <font @click="operaShoppingCarDelete('all')">删除选中商品</font>
          </div>

          <div class="shopping-set_sel-info">
            <span class="shopping-set_nums">
              共{{shoppingInfo.shoppingCarGoodsNum}}件商品，已选
              <font>{{shoppingInfo.shoppingCarGoodsSelectNum}}</font>件
            </span>
            <span>
              商品合计：
              <font>¥ {{shoppingInfo.shoppingCarAllPrice}}</font>
            </span>
            <!-- <span>优惠：
              <font>¥ {{shoppingInfo.shoppingCarDiscount}}</font>
            </span>-->
            <span class="shopping-set_all">
              应付总额：
              <font>¥ {{shoppingInfo.shoppingCarAllPrice}}</font>
            </span>
          </div>
          <div class="shopping-set_sel-btn">
            <el-button type="danger" class="shopping-set_sel-btn_s" @click="operaSubmit">下单结算</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { selectShopCar, addProductCar, deleteProductCar } from "@/api";
import shoppingPublic from "@/assets/js/shoppingPublic";
export default {
  name: "shopping-car",
  data() {
    return {
      selectedAll: true,
      shoppingCarGoods: [],
      multipleSelection: [],
      shoppingInfo: {
        shoppingCarAllPrice: 0,
        shoppingCarGoodsNum: 0,
        shoppingCarGoodsSelectNum: 0,
        shoppingCarDiscount: 0.0
      },
      shoppingCarInfo: {
        userId: this.$store.state.userInfo.staffId,
        systemType: this.$store.state.userInfo.brandId
      }
    };
  },
  created() {
    this.operaShoppingCarGoods();
  },
  methods: {
    //获取购物车数据
    operaShoppingCarGoods() {
      selectShopCar(this.shoppingCarInfo).then(res => {
        this.shoppingCarGoods = res.obj;
        this.shoppingInfo.shoppingCarAllPrice = 0;
        this.shoppingCarGoods.forEach((val, index, arr) => {
          val.hanld = true;
          val.selected = true;
          this.shoppingInfo.shoppingCarAllPrice += val.subtotal * 1;
        });
        this.shoppingInfo.shoppingCarAllPrice = shoppingPublic.computePrice(this.shoppingInfo.shoppingCarAllPrice,2);
        this.shoppingInfo.shoppingCarGoodsNum = res.obj.length;
        this.shoppingInfo.shoppingCarGoodsSelectNum = res.obj.length;
        this.$store.commit('SEARCH_SHOPPING_GOODS','');
      });
    },
    //全选
    operaAllSelect() {
      if (this.selectedAll) {
        this.selectedAll = false;
        this.shoppingCarGoods.forEach((vals, index, arr) => {
          vals.selected = false;
        });
      } else {
        this.selectedAll = true;
        this.shoppingCarGoods.forEach((vals, index, arr) => {
          vals.selected = true;
        });
      }
      this.operaComputedPrice();
    },
    //单选
    operaStandSelect(items, index) {
      let isTrue = "";

      items.selected = !items.selected;
      this.$set(this.shoppingCarGoods, index, items);
      this.shoppingCarGoods.forEach((val, index, arr) => {
        isTrue += val.selected;
      });
      if (isTrue.indexOf("false") > -1) {
        this.selectedAll = false;
      } else {
        this.selectedAll = true;
      }
      this.operaComputedPrice();
    },
    //如果输入的不是整数，自适应为0
    operaHandleChange(item, index) {
      item.subtotal = shoppingPublic.computePrice(item.price * item.quantity,2);
      this.operaComputedPrice();
    },
    //计算价格
    operaComputedPrice() {
      this.shoppingInfo.shoppingCarGoodsSelectNum = 0;
      this.shoppingInfo.shoppingCarAllPrice = 0;
      this.shoppingCarGoods.forEach((val, index, arr) => {
        if (val.selected && val.hanld) {
          this.shoppingInfo.shoppingCarAllPrice += val.subtotal * 1;
          this.shoppingInfo.shoppingCarGoodsSelectNum++;
        }
      });
        this.shoppingInfo.shoppingCarAllPrice = shoppingPublic.computePrice(this.shoppingInfo.shoppingCarAllPrice,2);
    },

    //刪除購物車商品
    operaShoppingCarDelete(items) {
      let productArr = [],
        deleteObj = {};
      if (typeof items == "object") {
        productArr.push(items.productId);
        this.shoppingCarGoods.forEach((val, index, arr) => {
          if (val.productId == items.productId) {            
            val.hanld = false;
            this.$set(this.shoppingCarGoods, index, val);
          }
        });
      } else {
        this.shoppingCarGoods.forEach((val, index, arr) => {
          if (val.selected) {
            productArr.push(val.productId);
            val.hanld = false;
            this.$set(this.shoppingCarGoods, index, val);
          }
        });
      }
      deleteObj.productIds = productArr;
      deleteObj.userId = this.$store.state.userInfo.staffId;
      deleteObj.systemType = this.$store.state.userInfo.brandId;
      deleteProductCar(deleteObj).then(res => {
        if (res.code == 20001) {
          this.$emit("shoppingCars", "shoppingCarGoods");
          this.operaComputedPrice();
        } else {
          this.operaShoppingCarGoods();
        }
        this.$message({
          type: res.code == 20001 ? "success" : "error",
          message: res.msg
        });
      });
    },
    //提交订单
    operaSubmit(){
      let submitArr = [];
      this.shoppingCarGoods.forEach((val, index, arr) => {
        if (val.selected && val.hanld) {
          submitArr.push(val);
        }
      });
      sessionStorage.setItem('submitArr',JSON.stringify(submitArr));
      this.$router.push('/shoppingMall/shoppingSubmit');
    }
  }
};
</script>
<style type="text/css">
.shopping-car {
  margin-top: 30px;
  background: #ffffff;
}
/*自定义table*/
.shopping-center {
  text-align: center;
  line-height: 80px;
  font-size: 14px;
}
.shopping-car-table {
  width: 100%;
}
.shopping-car-table_head {
  width: 100%;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border-bottom: 1px solid #d5d9e3;
}
.shopping-select {
  float: left;
  margin-top: 33px;
  margin-left: 67px;
  margin-right: 10px;
  width: 18px;
  height: 18px;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  line-height: 18px;
  border: 1px solid #c0c5cf;
  border-radius: 3px;
  cursor: pointer;
}
.shopping-table_select span font {
  float: left;
  width: 100%;
}
.shopping-table_select font {
  float: left;
}
.shopping-table_select {
  width: 150px;
}
.shopping-table_goods {
  width: 325px;
}
.shopping-table_price {
  width: 150px;
}
.shopping-table_num {
  width: 200px;
}
.shopping-table_computed {
  width: 175px;
}
.shopping-table_do {
  width: 200px;
}
.shopping-car-table_body {
  padding-top: 20px;
  padding-bottom: 40px;
  width: 100%;
}
.shopping-car-table_body-li {
  padding-top: 20px;
  width: 100%;
}
.shopping-car_goods-find {
  padding-left: 10px;
  width: 100%;
  display: flex;
}
.shopping-car_goods-find-img {
  margin-right: 23px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.shopping-car_goods-find img {
  max-width: 80px;
  max-height: 80px;
}
.shopping-car_goods-find dl {
  flex: 1;
}
.shopping-car_goods-find dl dt,
.shopping-car_goods-find dl dd {
  width: 100%;
}
.shopping-car_goods-find dl dt {
  padding-top: 16px;
  font-size: 16px;
  color: #444444;
}
.shopping-car_goods-find dl font {
  margin-right: 5px;
  font-size: 12px;
  color: #999999;
}
.shopping-red {
  color: #f83c57;
}
.shopping-table_do span {
  cursor: pointer;
}

.shopping-pro-infos_num-compute {
  padding-left: 10px;
}
.shopping-pro-infos_num-compute .el-input-number {
  width: 123px;
  height: 38px;
  line-height: 36px;
}
.shopping-pro-infos_num-compute .el-input-number__decrease,
.shopping-pro-infos_num-compute .el-input-number__increase,
.shopping-pro-infos_num-compute .el-input__inner {
  border-radius: 0;
}
.shopping-pro-infos_num-compute .el-input-number__decrease,
.shopping-pro-infos_num-compute .el-input-number__increase {
  width: 30px;
  background: #ffffff;
}
.shopping-pro-infos_num-compute .el-input__inner {
  height: 38px;
}
.shopping-pro-infos_num-compute .el-input-number .el-input__inner {
  padding: 0;
}
.shopping-table_num .shopping-pro-infos_num-compute {
  margin-left: 38.5px;
}
/*下单结算*/
.shopping-settlement {
  margin-top: 20px;
  background: #ffffff;
}
.shopping-set {
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  width: 100%;
  height: 80px;
}
.shopping-selected {
  float: left;
  margin-top: 15px;
  margin-left: 67px;
  margin-right: 10px;
  width: 18px;
  height: 18px;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  line-height: 18px;
  border: 1px solid #c0c5cf;
  border-radius: 3px;
  cursor: pointer;
}
.shopping-set_sel {
  line-height: 48px;
  font-size: 14px;
  color: #444444;
}
.shopping-delete {
  margin-left: 30px;
  margin-right: 9px;
}
.shopping-set_sel-info {
  flex: 1;
  line-height: 48px;
  text-align: right;
}
.shopping-set_sel-btn {
  margin-right: 40px;
  margin-left: 17px;
  width: 140px;
}
.shopping-set_sel-btn .shopping-set_sel-btn_s {
  width: 140px;
  height: 48px;
  font-size: 16px;
  color: #ffffff;
  background: #f83c57;
  border-radius: 5px !important;
}
.shopping-set_sel-info span {
  display: inline;
  padding-left: 5px;
}
.shopping-set_nums font {
  padding-left: 5px;
  padding-right: 5px;
  color: #f83c57;
}
.shopping-set_all font {
  font-size: 24px;
  color: #f83c57;
}
.shopping-select.on,
.shopping-selected.on {
  border: none;
  background: #f83b56;
}
</style>


// WEBPACK FOOTER //
// src/components/shoppingMall/shoppingCar.vue